import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = ["stroke-width"];
const _hoisted_3 = ["stroke-width"];
const _hoisted_4 = ["stroke-width"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'user-in-circle',
    props: {
        strokeWidth: {
            type: Number,
            default: 1.5,
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("rect", {
                    x: "2",
                    y: "2",
                    width: "16",
                    height: "16",
                    rx: "8",
                    stroke: "currentColor",
                    "stroke-width": props.strokeWidth
                }, null, 8, _hoisted_2),
                _createElementVNode("circle", {
                    cx: "10",
                    cy: "8.33337",
                    r: "2.5",
                    stroke: "currentColor",
                    "stroke-width": props.strokeWidth
                }, null, 8, _hoisted_3),
                _createElementVNode("path", {
                    d: "M15 15.5903C13.7784 14.2063 11.9912 13.3334 10 13.3334C8.00885 13.3334 6.22157 14.2063 5 15.5903",
                    stroke: "currentColor",
                    "stroke-width": props.strokeWidth
                }, null, 8, _hoisted_4)
            ]));
        };
    }
});
